import { createRouter, createWebHistory } from "vue-router";

import { useAuth } from "src/composables/auth";

function passRouteToProps(route) {
  return {
    queryParams: route.query,
    fieldName: route.params.fieldName,
    fieldValue: route.params.fieldValue,
  };
}

let routes = [
  //Dashboard routes

  //alerts routes
  {
    path: "/alerts/:fieldName?/:fieldValue?",
    name: "alertslist",
    component: () => import("./pages/alerts/list.vue"),
    props: (route) => passRouteToProps(route),
  },

  {
    path: "/alerts/view/:id",
    name: "alertsview",
    component: () => import("./pages/alerts/view.vue"),
    props: true,
  },
  // AppSettings Routes
  {
    path: "/appsettings/:fieldName?/:fieldValue?",
    name: "appsettingslist",
    component: () => import("./pages/appsettings/list.vue"),
    props: (route) => passRouteToProps(route),
  },

  {
    path: "/appsettings/view/:id",
    name: "appsettingsview",
    component: () => import("./pages/appsettings/view.vue"),
    props: true,
  },

  {
    path: "/appsettings/add",
    name: "appsettingsadd",
    component: () => import("./pages/appsettings/add.vue"),
    props: true,
  },

  {
    path: "/appsettings/edit/:id",
    name: "appsettingsedit",
    component: () => import("./pages/appsettings/edit.vue"),
    props: true,
  },

  // PayBill Configuration Routes
  {
    path: "/payment-config/paybill",
    name: "paybillconfigview",
    component: () => import("./pages/paymentconfig/paybill.vue"),
    props: true,
  },

  {
    path: "/payment-config/paybill/edit",
    name: "paybillconfigedit",
    component: () => import("./pages/paymentconfig/edit.vue"),
    props: true,
  },
  //billingperiods routes
  {
    path: "/billingperiods/:fieldName?/:fieldValue?",
    name: "billingperiodslist",
    component: () => import("./pages/billingperiods/list.vue"),
    props: (route) => passRouteToProps(route),
  },

  {
    path: "/billingperiods/view/:id",
    name: "billingperiodsview",
    component: () => import("./pages/billingperiods/view.vue"),
    props: true,
  },

  {
    path: "/billingperiods/add",
    name: "billingperiodsadd",
    component: () => import("./pages/billingperiods/add.vue"),
    props: true,
  },

  {
    path: "/billingperiods/edit/:id",
    name: "billingperiodsedit",
    component: () => import("./pages/billingperiods/edit.vue"),
    props: true,
  },

  //billingtype routes
  {
    path: "/billingtype/:fieldName?/:fieldValue?",
    name: "billingtypelist",
    component: () => import("./pages/billingtype/list.vue"),
    props: (route) => passRouteToProps(route),
  },

  {
    path: "/billingtype/view/:id",
    name: "billingtypeview",
    component: () => import("./pages/billingtype/view.vue"),
    props: true,
  },

  {
    path: "/billingtype/add",
    name: "billingtypeadd",
    component: () => import("./pages/billingtype/add.vue"),
    props: true,
  },

  {
    path: "/billingtype/edit/:id",
    name: "billingtypeedit",
    component: () => import("./pages/billingtype/edit.vue"),
    props: true,
  },

  //combinedbillsview routes
  {
    path: "/combinedbillsview/:fieldName?/:fieldValue?",
    name: "combinedbillsviewlist",
    component: () => import("./pages/combinedbillsview/list.vue"),
    props: (route) => passRouteToProps(route),
  },

  //customeraccount routes
  {
    path: "/customeraccount/:fieldName?/:fieldValue?",
    name: "customeraccountlist",
    component: () => import("./pages/customeraccount/list.vue"),
    props: (route) => passRouteToProps(route),
  },

  {
    path: "/customeraccount/view/:id",
    name: "customeraccountview",
    component: () => import("./pages/customeraccount/view.vue"),
    props: true,
  },

  {
    path: "/customeraccount/edit/:id",
    name: "customeraccountedit",
    component: () => import("./pages/customeraccount/edit.vue"),
    props: true,
  },

  //customers routes
  {
    path: "/customers/:fieldName?/:fieldValue?",
    name: "customerslist",
    component: () => import("./pages/customers/list.vue"),
    props: (route) => passRouteToProps(route),
  },

  {
    path: "/customers/view/:id",
    name: "customersview",
    component: () => import("./pages/customers/view.vue"),
    props: true,
  },

  {
    path: "/customers/add",
    name: "customersadd",
    component: () => import("./pages/customers/add.vue"),
    props: true,
  },

  {
    path: "/customers/edit/:id",
    name: "customersedit",
    component: () => import("./pages/customers/edit.vue"),
    props: true,
  },

  //depositdeductions routes
  {
    path: "/depositdeductions/:fieldName?/:fieldValue?",
    name: "depositdeductionslist",
    component: () => import("./pages/depositdeductions/list.vue"),
    props: (route) => passRouteToProps(route),
  },

  {
    path: "/depositdeductions/view/:id",
    name: "depositdeductionsview",
    component: () => import("./pages/depositdeductions/view.vue"),
    props: true,
  },

  {
    path: "/depositdeductions/add",
    name: "depositdeductionsadd",
    component: () => import("./pages/depositdeductions/add.vue"),
    props: true,
  },

  {
    path: "/depositdeductions/edit/:id",
    name: "depositdeductionsedit",
    component: () => import("./pages/depositdeductions/edit.vue"),
    props: true,
  },

  //depositrefunds routes
  {
    path: "/depositrefunds/:fieldName?/:fieldValue?",
    name: "depositrefundslist",
    component: () => import("./pages/depositrefunds/list.vue"),
    props: (route) => passRouteToProps(route),
  },

  {
    path: "/depositrefunds/view/:id",
    name: "depositrefundsview",
    component: () => import("./pages/depositrefunds/view.vue"),
    props: true,
  },

  {
    path: "/depositrefunds/add",
    name: "depositrefundsadd",
    component: () => import("./pages/depositrefunds/add.vue"),
    props: true,
  },

  {
    path: "/depositrefunds/edit/:id",
    name: "depositrefundsedit",
    component: () => import("./pages/depositrefunds/edit.vue"),
    props: true,
  },

  //deposits routes
  {
    path: "/deposits/:fieldName?/:fieldValue?",
    name: "depositslist",
    component: () => import("./pages/deposits/list.vue"),
    props: (route) => passRouteToProps(route),
  },

  {
    path: "/deposits/view/:id",
    name: "depositsview",
    component: () => import("./pages/deposits/view.vue"),
    props: true,
  },

  {
    path: "/deposits/add",
    name: "depositsadd",
    component: () => import("./pages/deposits/add.vue"),
    props: true,
  },

  {
    path: "/deposits/edit/:id",
    name: "depositsedit",
    component: () => import("./pages/deposits/edit.vue"),
    props: true,
  },

  //deposittypes routes
  {
    path: "/deposittypes/:fieldName?/:fieldValue?",
    name: "deposittypeslist",
    component: () => import("./pages/deposittypes/list.vue"),
    props: (route) => passRouteToProps(route),
  },

  {
    path: "/deposittypes/view/:id",
    name: "deposittypesview",
    component: () => import("./pages/deposittypes/view.vue"),
    props: true,
  },

  {
    path: "/deposittypes/add",
    name: "deposittypesadd",
    component: () => import("./pages/deposittypes/add.vue"),
    props: true,
  },

  {
    path: "/deposittypes/edit/:id",
    name: "deposittypesedit",
    component: () => import("./pages/deposittypes/edit.vue"),
    props: true,
  },

  //houses routes
  {
    path: "/houses/:fieldName?/:fieldValue?",
    name: "houseslist",
    component: () => import("./pages/houses/list.vue"),
    props: (route) => passRouteToProps(route),
  },

  {
    path: "/houses/view/:id",
    name: "housesview",
    component: () => import("./pages/houses/view.vue"),
    props: true,
  },

  {
    path: "/houses/add",
    name: "housesadd",
    component: () => import("./pages/houses/add.vue"),
    props: true,
  },

  {
    path: "/houses/edit/:id",
    name: "housesedit",
    component: () => import("./pages/houses/edit.vue"),
    props: true,
  },

  //messages routes
  {
    path: "/messages/:fieldName?/:fieldValue?",
    name: "messageslist",
    component: () => import("./pages/messages/list.vue"),
    props: (route) => passRouteToProps(route),
  },

  {
    path: "/messages/view/:id",
    name: "messagesview",
    component: () => import("./pages/messages/view.vue"),
    props: true,
  },

  {
    path: "/messages/add",
    name: "messagesadd",
    component: () => import("./pages/messages/add.vue"),
    props: true,
  },

  {
    path: "/messages/edit/:id",
    name: "messagesedit",
    component: () => import("./pages/messages/edit.vue"),
    props: true,
  },

  {
    path: "/messages/compose",
    name: "messagescompose",
    component: () => import("./pages/messages/compose.vue"),
    props: true,
  },

  //meterreadings routes
  {
    path: "/meterreadings/:fieldName?/:fieldValue?",
    name: "meterreadingslist",
    component: () => import("./pages/meterreadings/list.vue"),
    props: (route) => passRouteToProps(route),
  },

  {
    path: "/meterreadings/view/:id",
    name: "meterreadingsview",
    component: () => import("./pages/meterreadings/view.vue"),
    props: true,
  },

  {
    path: "/meterreadings/add",
    name: "meterreadingsadd",
    component: () => import("./pages/meterreadings/add.vue"),
    props: true,
  },

  {
    path: "/meterreadings/edit/:id",
    name: "meterreadingsedit",
    component: () => import("./pages/meterreadings/edit.vue"),
    props: true,
  },

  //meters routes
  {
    path: "/meters/:fieldName?/:fieldValue?",
    name: "meterslist",
    component: () => import("./pages/meters/list.vue"),
    props: (route) => passRouteToProps(route),
  },

  {
    path: "/meters/view/:id",
    name: "metersview",
    component: () => import("./pages/meters/view.vue"),
    props: true,
  },

  {
    path: "/meters/add",
    name: "metersadd",
    component: () => import("./pages/meters/add.vue"),
    props: true,
  },

  {
    path: "/meters/edit/:id",
    name: "metersedit",
    component: () => import("./pages/meters/edit.vue"),
    props: true,
  },

  //payments routes
  {
    path: "/payments/:fieldName?/:fieldValue?",
    name: "paymentslist",
    component: () => import("./pages/payments/list.vue"),
    props: (route) => passRouteToProps(route),
  },

  {
    path: "/payments/view/:id",
    name: "paymentsview",
    component: () => import("./pages/payments/view.vue"),
    props: true,
  },

  {
    path: "/payments/add",
    name: "paymentsadd",
    component: () => import("./pages/payments/add.vue"),
    props: true,
  },

  {
    path: "/payments/edit/:id",
    name: "paymentsedit",
    component: () => import("./pages/payments/edit.vue"),
    props: true,
  },

  //rentbills routes
  {
    path: "/rentbills/:fieldName?/:fieldValue?",
    name: "rentbillslist",
    component: () => import("./pages/rentbills/list.vue"),
    props: (route) => passRouteToProps(route),
  },

  {
    path: "/rentbills/view/:id",
    name: "rentbillsview",
    component: () => import("./pages/rentbills/view.vue"),
    props: true,
  },

  {
    path: "/rentbills/add",
    name: "rentbillsadd",
    component: () => import("./pages/rentbills/add.vue"),
    props: true,
  },

  {
    path: "/rentbills/edit/:id",
    name: "rentbillsedit",
    component: () => import("./pages/rentbills/edit.vue"),
    props: true,
  },

  //tariffs routes
  {
    path: "/tariffs/:fieldName?/:fieldValue?",
    name: "tariffslist",
    component: () => import("./pages/tariffs/list.vue"),
    props: (route) => passRouteToProps(route),
  },

  {
    path: "/tariffs/view/:id",
    name: "tariffsview",
    component: () => import("./pages/tariffs/view.vue"),
    props: true,
  },

  {
    path: "/tariffs/add",
    name: "tariffsadd",
    component: () => import("./pages/tariffs/add.vue"),
    props: true,
  },

  {
    path: "/tariffs/edit/:id",
    name: "tariffsedit",
    component: () => import("./pages/tariffs/edit.vue"),
    props: true,
  },

  //tenancy routes
  {
    path: "/tenancy/:fieldName?/:fieldValue?",
    name: "tenancylist",
    component: () => import("./pages/tenancy/list.vue"),
    props: (route) => passRouteToProps(route),
  },

  {
    path: "/tenancy/view/:id",
    name: "tenancyview",
    component: () => import("./pages/tenancy/view.vue"),
    props: true,
  },

  {
    path: "/tenancy/add",
    name: "tenancyadd",
    component: () => import("./pages/tenancy/add.vue"),
    props: true,
  },

  {
    path: "/tenancy/edit/:id",
    name: "tenancyedit",
    component: () => import("./pages/tenancy/edit.vue"),
    props: true,
  },

  {
    path: "/tenancy/inactive/:fieldName?/:fieldValue?",
    name: "tenancyinactive",
    component: () => import("./pages/tenancy/inactive.vue"),
    props: (route) => passRouteToProps(route),
  },

  {
    path: "/tenancy/active/:fieldName?/:fieldValue?",
    name: "tenancyactive",
    component: () => import("./pages/tenancy/active.vue"),
    props: (route) => passRouteToProps(route),
  },

  //users routes
  {
    path: "/users/:fieldName?/:fieldValue?",
    name: "userslist",
    component: () => import("./pages/users/list.vue"),
    props: (route) => passRouteToProps(route),
  },

  {
    path: "/users/view/:id",
    name: "usersview",
    component: () => import("./pages/users/view.vue"),
    props: true,
  },

  {
    path: "/index/register",
    name: "usersuserregister",
    component: () => import("./pages/index/userregister.vue"),
    props: true,
  },

  {
    path: "/account/edit",
    name: "usersaccountedit",
    component: () => import("./pages/account/accountedit.vue"),
    props: true,
  },

  {
    path: "/account",
    name: "usersaccountview",
    component: () => import("./pages/account/accountview.vue"),
    props: true,
  },

  {
    path: "/users/add",
    name: "usersadd",
    component: () => import("./pages/users/add.vue"),
    props: true,
  },

  {
    path: "/users/edit/:id",
    name: "usersedit",
    component: () => import("./pages/users/edit.vue"),
    props: true,
  },

  //waterbills routes
  {
    path: "/waterbills/:fieldName?/:fieldValue?",
    name: "waterbillslist",
    component: () => import("./pages/waterbills/list.vue"),
    props: (route) => passRouteToProps(route),
  },

  {
    path: "/waterbills/view/:id",
    name: "waterbillsview",
    component: () => import("./pages/waterbills/view.vue"),
    props: true,
  },

  {
    path: "/waterbills/add",
    name: "waterbillsadd",
    component: () => import("./pages/waterbills/add.vue"),
    props: true,
  },

  {
    path: "/waterbills/edit/:id",
    name: "waterbillsedit",
    component: () => import("./pages/waterbills/edit.vue"),
    props: true,
  },

  //Password reset routes
  {
    path: "/index/forgotpassword",
    name: "forgotpassword",
    component: () => import("./pages/index/forgotpassword.vue"),
    props: true,
  },
  {
    path: "/index/resetpassword",
    name: "resetpassword",
    component: () => import("./pages/index/resetpassword.vue"),
    props: true,
  },
  {
    path: "/index/resetpassword_completed",
    name: "resetpassword_completed",
    component: () => import("./pages/index/resetpassword_completed.vue"),
    props: true,
  },

  {
    path: "/error/forbidden",
    name: "forbidden",
    component: () => import("./pages/errors/forbidden.vue"),
    props: true,
  },
  {
    path: "/error/notfound",
    name: "notfound",
    component: () => import("./pages/errors/pagenotfound.vue"),
    props: true,
  },
  {
    path: "/:catchAll(.*)",
    component: () => import("./pages/errors/pagenotfound.vue"),
  },
];

export default () => {
  const auth = useAuth();

  const user = auth.user;
  if (user) {
    routes.push({
      path: "/",
      alias: "/home",
      name: "home",
      component: () => import(`./pages/home/home.vue`),
    });
  } else {
    routes.push({
      path: "/",
      alias: "/index",
      name: "index",
      component: () => import("./pages/index/index.vue"),
    });
  }

  const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPostion) {
      if (savedPostion) return savedPostion;
      return { top: 0 };
    },
  });

  router.beforeEach((to, from, next) => {
    const user = auth.user;
    let path = to.path;
    let authRequired = auth.pageRequiredAuth(path);

    //authenticate user
    if (authRequired && !user) {
      //user is not logged. redirect to login
      return next({ path: "/", query: { nexturl: to.fullPath } });
    }

    if (user && to.name == "index") {
      //already logged in, show home when try to access index page
      return next({ path: "/home" });
    }

    //navigate to redirect url if available
    if (to.name == "home" && to.query.nexturl) {
      return next({ path: to.query.nexturl });
    }

    //close dialog from previous page
    //store.dispatch('app/closeDialogs');

    //continue to specified route
    next();
  });

  return router;
};
